<script>
import Button from "@/components/atoms/button";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Divider from "@/components/atoms/divider";
import ButtonGroup from "@/components/molecules/button-group";
import StickyFooter from "@/components/molecules/sticky-footer";
import EtatPanierItemList from "@/components/organisms/etat-panier/etat-panier-item-list/mobile";
import { etatPanierCompleteAfterConnectProps } from "./mixin";
import { useEtatPanier } from "../mixin";

export default {
  name: "EtatPanierCompleteMobile",
  components: {
    Button,
    Icon,
    Badge,
    Divider,
    ButtonGroup,
    StickyFooter,
    EtatPanierItemList
  },
  props: {
    ...etatPanierCompleteAfterConnectProps()
  },
  emits: ["ignore", "complete"],
  setup(props) {
    const { status, produits, dateLastUsage } = useEtatPanier(props.etatPanier);
    return { status, produits, dateLastUsage };
  }
};
</script>

<template>
  <div>
    <div class="u-text-center">
      <Badge
        variant="secondary"
        class="u-mb-sm u-p-xs"
        circle
        size="xlg"
      >
        <Icon
          name="cart"
          variant="white"
          size="md"
        />
      </Badge>
      <p class="u-ml-md@md u-mr-md@md">
        Lors de votre visite du {{ dateLastUsage }}, vous aviez commencé un panier de {{ produits.length }} {{ pluralize(produits.length, 'produit') }}
      </p>
      <div class="u-mt-md">
        <div class="u-ml-md@md u-mr-md@md">
          <Divider dotted />
          <h1 class="u-font-secondary u-color-primary u-font-24 u-font-700 u-mt-md u-mb-md">
            <template v-if="produits.length === 1">
              Souhaitez-vous compléter le panier en cours avec le produit suivant ?
            </template>
            <template v-else>
              Souhaitez-vous compléter le panier en cours avec les produits suivants ?
            </template>
          </h1>
        </div>
        <div class="u-mb-xlg u-ml-md@md u-mr-md@md">
          <EtatPanierItemList :produits="produits" />
        </div>
        <StickyFooter :in-dom="false">
          <ButtonGroup>
            <Button
              outline
              variant="primary"
              size="md"
              radius="full"
              class="u-mt-xs"
              @click="$emit('ignore')"
            >
              Ignorer
            </Button>
            <Button
              variant="secondary"
              size="md"
              radius="full"
              class="u-mt-xs"
              @click="$emit('complete')"
            >
              Compléter mon panier
            </Button>
          </ButtonGroup>
        </StickyFooter>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
